import React, { PropsWithChildren, useContext } from 'react';
import ScrimBase, { ScrimBaseProps } from './scrimBase';
import { MessageType } from '../../core/localization';
import { LocaleCtx } from '../../contexts/locale.context';

type OwnProps = ScrimBaseProps & {
  label?: MessageType;
};
export type ScrimProps = PropsWithChildren<OwnProps>;
const Scrim: React.FC<ScrimProps> = (props) => {
  const { translate } = useContext(LocaleCtx);
  const label = props.label ? translate(props.label) : undefined;
  return <ScrimBase {...{ ...props, label }} />;
};

export default Scrim;
